var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcFramework(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1327_17623)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.33789 19.1903H1.45508C0.781982 19.1903 0.234375 18.6749 0.234375 18.0414V13.4458C0.234375 12.8123 0.781982 12.2969 1.45508 12.2969H6.33789C7.01099 12.2969 7.55859 12.8123 7.55859 13.4458V18.0414C7.55859 18.6749 7.01099 19.1903 6.33789 19.1903ZM2.06543 17.4669H5.72754V14.0202H2.06543V17.4669Z",
    fill: "#76A81F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5449 19.1903H13.6621C12.989 19.1903 12.4414 18.6749 12.4414 18.0414V13.4458C12.4414 12.8123 12.989 12.2969 13.6621 12.2969H18.5449C19.218 12.2969 19.7656 12.8123 19.7656 13.4458V18.0414C19.7656 18.6749 19.218 19.1903 18.5449 19.1903ZM14.2725 17.4669H17.9346V14.0202H14.2725V17.4669Z",
    fill: "#76A81F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.103 13.6341C15.5974 13.6341 15.1875 13.2483 15.1875 12.7725V11.0037C15.1875 10.9147 15.1282 10.8601 15.0858 10.8601H4.91327C4.87079 10.8601 4.81152 10.9147 4.81152 11.0037V12.7725C4.81152 13.2483 4.40161 13.6341 3.896 13.6341C3.39038 13.6341 2.98047 13.2483 2.98047 12.7725V11.0037C2.98047 9.97426 3.84753 9.13672 4.91327 9.13672H15.0858C16.1515 9.13672 17.0186 9.97426 17.0186 11.0037V12.7725C17.0186 13.2483 16.6086 13.6341 16.103 13.6341Z",
    fill: "#76A81F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99951 10.8612C9.4939 10.8612 9.08398 10.4754 9.08398 9.99954V7.1273C9.08398 6.65142 9.4939 6.26562 9.99951 6.26562C10.5051 6.26562 10.915 6.65142 10.915 7.1273V9.99954C10.915 10.4754 10.5051 10.8612 9.99951 10.8612Z",
    fill: "#76A81F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4414 7.70198H7.55859C6.8855 7.70198 6.33789 7.18658 6.33789 6.55308V1.95749C6.33789 1.32399 6.8855 0.808594 7.55859 0.808594H12.4414C13.1145 0.808594 13.6621 1.32399 13.6621 1.95749V6.55308C13.6621 7.18658 13.1145 7.70198 12.4414 7.70198ZM8.16895 5.97863H11.8311V2.53194H8.16895V5.97863Z",
    fill: "#76A81F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1327_17623"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFramework);
export default __webpack_public_path__ + "static/media/ic_framework.69107b08054b0cc9342a41c4e547acd0.svg";
export { ForwardRef as ReactComponent };